
import { ref, onMounted, onUnmounted } from "vue"
import { useRoute } from "vue-router"
import { Toast } from "vant"
import { useI18n } from "vue-i18n"
import httpUtil from "@/assets/script/utils/http.util"

export default {
  setup() {
    const changeLang = ref(false)
    const router = useRoute()
    const appId = Number(router.query.appId)
    const { t, locale } = useI18n()
    const iphoneDownUrl = ref(
      "https://apps.apple.com/cn/app/%E6%99%BA%E8%83%BD%E5%AF%9D%E5%85%B7/id1493894594?uo=4"
    )
    const androidDownUrl = ref(
      "https://image.shiyuec.com/mpe/app/%E6%99%BA%E8%83%BD%E5%AF%9D%E5%85%B7_release_v5.3.8_20250514_1728.apk"
    )

    const toast = Toast.loading({
      forbidClick: true,
      duration: 0
    })
    httpUtil
      .get("https://api.mpebedding.com/prod-api/mpe/download/getDownloadUrl")
      .then((res: any) => {
        iphoneDownUrl.value = res.smartBeddingCnIos
        androidDownUrl.value = res.smartBeddingCnAndroid
        if (appId == 2) {
          iphoneDownUrl.value = res.aiBedEnIos
          androidDownUrl.value = res.aiBedEnAndroid
        }
        if (appId == 3) {
          iphoneDownUrl.value = res.ccooSmartBedroomIos
          androidDownUrl.value = res.ccooSmartBedroomAndroid
        }
        toast.clear()
      })

    const language = ref("简体中文")
    const activeIndex = ref(-1)
    const lanArr = ref([
      { name: "简体中文", code: "zh" }, // 简体中文
      { name: "English", code: "en" }, // 英语
      { name: "繁體中文", code: "zu" }, // 繁体中文
      { name: "العربية", code: "ar" }, // 阿拉伯语
      { name: "Deutsch", code: "de" }, // 德语
      { name: "Italiano", code: "it" }, // 意大利语
      { name: "日本語", code: "ja" }, // 日语
      { name: "한국어", code: "ko" }, // 韩语
      { name: "Русский", code: "ru" }, // 俄语
      { name: "Español", code: "es" }, // 西班牙语
      { name: "Português", code: "pt" }, // 葡萄牙语
      { name: "ไทย", code: "th" }, // 泰语
      { name: "Français", code: "fr" }, // 法语
      { name: "Nederlands", code: "nl" }, // 荷兰语
      { name: "Türkçe", code: "tr" }, // 土耳其语
      { name: "Tiếng Việt", code: "vi" }, // 越南语
      { name: "Bahasa Indonesia", code: "id" } // 印尼语
    ])
    const title = ref("")
    document.title = "智能寝具"
    title.value = " 智能寝具 "
    if (appId == 2) {
      lanArr.value = lanArr.value.filter(
        (item) => item.code != "zh" && item.code != "zu"
      )
      language.value = "English"
      locale.value = "en"
      document.title = "AI Bed"
      title.value = " AI Bed "
    }
    if (appId == 3) {
      document.title = "CCOO智慧卧室"
      title.value = " CCOO智慧卧室 "
    }
    const handleClickOutside = (event: any) => {
      if (
        !event.target.closest(".lang-list") &&
        !event.target.closest(".lang-btn")
      ) {
        changeLang.value = false
      }
    }
    const changeLanguage = (lang: any, index: number) => {
      locale.value = lang.code
      changeLang.value = false
      activeIndex.value = index
      language.value = lang.name
    }
    const downJump = (type: string) => {
      switch (type) {
        case "iphone":
          window.location.href = iphoneDownUrl.value
          break
        case "android":
          window.location.href = androidDownUrl.value
          break
      }
    }
    onMounted(() => {
      window.addEventListener("click", handleClickOutside)
    })

    onUnmounted(() => {
      window.removeEventListener("click", handleClickOutside)
    })

    return {
      changeLang,
      downJump,
      language,
      changeLanguage,
      lanArr,
      activeIndex,
      appId,
      title
    }
  }
}
